import { render } from "./App.vue?vue&type=template&id=23eafa96"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23eafa96&lang=css"

import exportComponent from "/codebuild/output/src821934687/src/cuco-prova-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__